<template>

<div class="main list-view no-sub-header">

	<div class="filters">
		<div v-if="!enrolled">
			You are not currently enrolled in D-Link.
		</div>

		<div v-else-if="showDetail">
			<div v-if="cartDetail.order_count > 0">
				You've already placed <b>{{ cartDetail.order_count }}</b> order{{ cartDetail.order_count > 1 ? 's' : '' }} for this offer.
				<div class="divider"></div>
			</div>
			<div v-if="!cartDetail.expires || cartDetail.expires > today">
				You can place {{ cartDetail.order_count > 0 ? 'another' : 'an' }} order through your distributor account.
			</div>
			<div v-else>
				This offer has expired and is no longer available for ordering.
			</div>
			<div class="divider"></div>
			<div :class="['button', !cartDetail.expires || cartDetail.expires > today ? 'primary' : 'disabled']" @click="placeOrder()">Place Order</div>

			<div class="divider"></div>
			<div class="extra-menu-item" @click="backToList()">Back to List</div>
		</div>

		<div v-else>
			<div class="label-group">
				<label>Start</label>
				<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label>End</label>
				<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label></label>
				<div class="button small neutral" @click="getList(1)">Filter Dates</div>
			</div>
		</div>
	</div>

	<div v-if="!enrolled" style="margin: 0 2em; max-width: 45em;">
		<img src="https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/marketing/dlinklogo.png" style="max-width: 120px; margin: 1em 0;"/>
		<h3 style="margin: 0.5em 0 1em 0;">Your FREE connection to your distributor's purchasing power.</h3>
		<p>Sponsored by RSR Group and CDS.</p>
		<p>When you enroll in D-link, you'll become part of an exclusive group of RSR customers who receive expert buying advice based on the industry's most accurate sales and inventory data.</p>
		<p>Enrolling is easy with just one click...</p>
		<div class="button action" style="margin: 1em 0 2em 0;" @click="sendEnrollment()">Enroll in Dlink</div>
		<p>Contact us if you don't have an RSR account.</p>
	</div>

	<div v-else-if="!showDetail" class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <div v-else class="list-detail" style="padding: 0 0 0 1em;">
            <div v-for="(cart, index) in list" class="three-columns clickable-list-item" style="padding: 0.5em;" @click="setDetail(cart)">
				<div>
					<div v-if="cart.distributor">
						<label class="full">Distributor</label>
						{{ cart.distributor.company_name }}
					</div>
					<div v-if="cart.sales_rep" class="v-spaced">
						<label class="full">Sales Rep</label>
						{{ cart.sales_rep.first_name }} {{ cart.sales_rep.last_name }}
					</div>
				</div>
				<div>
					<div>
						<label class="full">Description</label>
						{{ cart.description }}
					</div>
					<div class="v-spaced">
						<label class="full">Items</label>
						There are {{ cart.item_count }} items in this offer
					</div>
				</div>
				<div>
					<div>
						<label class="full">Updated</label>
						{{ cart.updated }}
					</div>
					<div class="v-spaced">
						<label class="full">Expires</label>
						{{ cart.expires ? $moment(cart.expires).format('MM/DD/YYYY') : 'N/A' }}
					</div>
				</div>
			</div>
        </div>

	</div>

	<div v-if="showDetail" class="detail">
		<h3>Offer from {{ cartDetail.distributor.company_name }}</h3>
		<div class="two-columns" style="margin: 1em 0 0 0; grid-template-columns: 1fr 17em;">
			<div>
				<label class="full">Description</label>
				<div class="v-spaced">{{ cartDetail.description }}</div>
				<label class="full v-spaced">Message</label>
				<div v-html="cartDetail.content"></div>

				<div style="margin: 1em 0; padding: 1em 0; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc;">
					<table class="data-list">
						<tr>
							<th></th>
							<th class="left">UPC / Item</th>
							<th class="left">Description</th>
							<th class="right">Available</th>
							<th class="right">Cost</th>
							<th class="center">Qty</th>
							<th></th>
						</tr>
						<tr v-for="(item, index) in cartDetail.items" class="list-item" :style="{ 'background-color': item.quantity == 0 ? '#f4f4f4' : 'transparent' }">
							<td class="center" style="padding: 0.5em 0;"><img :src="item.image_src" style="max-width: 40px;"/></td>
							<td class="left">{{ item.upc }}<br>{{ item.item_number || 'Not Carried' }}</td>
							<td class="left">{{ item.short_description }}</td>
							<td class="right">{{ item.available }}</td>
							<td class="right">${{ item.cost }}</td>
							<td class="center"><input type="number" v-model="item.quantity" style="font-size: 0.9em; width: 4em;" @change="saveQuantity(item)" /></td>
							<td class="center"><i v-if="item.quantity > 0" class="fa fa-trash clickable" @click="deleteItem(item)"></i>
							</td>
						</tr>
						<tr>
							<td colspan="4" class="right" style="padding: 1em 0 0 0;">Total</td>
							<td class="right" style="padding: 1em 0 0 0;"><b>${{ orderTotal }}</b></td>
						</tr>
					</table>
				</div>

			</div>
			<div style="border-left: 1px solid #ccc; padding: 0 0 0 1em;">
				<div v-if="cartDetail.distributor">
					<label class="full">Distributor</label>
					<b>{{ cartDetail.distributor.company_name }}</b>
				</div>
				<div v-if="cartDetail.sales_rep" class="v-spaced">
					<label class="full">Sales Rep</label>
					<b>{{ cartDetail.sales_rep.first_name }} {{ cartDetail.sales_rep.last_name }}</b>
				</div>
				<!-- <div class="v-spaced">
					<label class="full">Created</label>
					<b>{{ $moment(cartDetail.created).format('MM/DD/YYYY hh:mm A') }}</b>
				</div> -->
                <div v-if="cartDetail.created != cartDetail.last_updated">
                    <label class="full">Sent</label>
					<b>{{ $moment(cartDetail.last_updated).format('MM/DD/YYYY hh:mm A') }}</b>
                </div>
				<div v-if="cartDetail.expires" class="v-spaced">
					<label class="full">Expires</label>
					<b>{{ cartDetail.expires ? $moment(cartDetail.expires).format('MM/DD/YYYY') : 'N/A' }}</b>
				</div>
				<div v-for="(order, index) in cartDetail.orders" class="v-spaced">
					<router-link :to="'/orders-sales/orders/detail/' + order.client_order_id">
						<label class="full">Ordered</label>
						<b>{{ $moment(order.order_date).format('MM/DD/YYYY hh:mm A') }}</b>
					</router-link>
				</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading || saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
export default {
	name: 'dlink-carts',
	data() {
		return {
            loading: false,
			enrolled: true,
			today: '',
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			list: [],
			paging: {},
			showDetail: false,
			cartDetail: {},
			cartItems: [],
			compassAPI: '',
			saving: false
		}
	},
	created() {
		if (this.getDevEnvironment && document.location.hostname.indexOf('cdssandbox') == -1) {
			this.compassAPI = 'https://compassapi.test:8088/api.php'
		} else {
			this.compassAPI = 'https://app.nssncompass.com/api.php'
		}
		this.clearFilters()
	},
	computed: {
		orderTotal() {
			let total = 0
			this.cartDetail.items.forEach(item => {
				total += item.cost * item.quantity
			})
			return total.toFixed(2)
		}
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				start_date: '',
				end_date: '',
				cart_id: '',
				client_id: this.getClientId
			}
			var oneMonthAgo = new Date()
			this.today = oneMonthAgo.toISOString().slice(0,10)
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date
			if (this.$route.query.cart_id) {
				this.filters.cart_id = this.$route.query.cart_id
			}
			this.getList()
		},
		toggleFilter(which) {

        },
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading DLink offers...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: this.compassAPI + '?action=get_list_dlink_carts', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (!obj.enrolled) {
					this.enrolled = false
					this.message = ''
					return
				}
				if (obj.list) {
	                this.list = obj.list
					if (this.filters.cart_id && this.list.length == 1) {
						this.setDetail(this.list[0])
					} else {
						this.message = ''
					}
				}
                if (obj.paging) {
                    this.paging = obj.paging
                }
				if (this.filters.cart_id) {
					this.filters.cart_id = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		sendEnrollment() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Enrolling in DLink...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: this.compassAPI + '?action=dlink_enrollment', data: { user_name: this.getUser.user_name, source: 'dlink', distributor_code: 'RSR' } }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Enrollment successful!'
					setTimeout(() => {
						this.notEnrolled = false
						this.message = ''
					}, 2500)
				} else {
					if (obj.enrolled) {
						this.enrolled = true
						this.message = ''
						return
					}
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setDetail(cart) {
			this.loading = true
			this.message = 'Loading DLink offer items...'
			this.messageStatus = 'waiting'
			// iterate cartDetail.items and get product details
			let productIds = []
			cart.items.forEach(item => {
				productIds.push(item.product_id)
			})
			this.apiCall({ destination: 'get_list_distributor_cart_items', data: { product_ids: productIds, distributor_id: cart.distributor_id } }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (obj.status == 'success' && obj.list) {
					cart.items.forEach(item => {
						let product = obj.list.find(product => product.product_id == item.product_id)
						if (product) {
							// merge item with product
							item = Object.assign(item, product)
						}
					})
					this.cartDetail = cart
					this.showDetail = true
					this.message = ''
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
		saveQuantity(item) {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Saving item quantity...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: this.compassAPI + '?action=save_dlink_cart_quantities', data: { cart_item_id: item.cart_item_id, quantity: item.quantity } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
	                this.message = 'Quantities saved!'
					this.messageTimeout = 750
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		deleteItem(item) {
			// set quantity to 0
			let index = this.cartDetail.items.findIndex(i => i.cart_item_id == item.cart_item_id)
			this.cartDetail.items[index].quantity = 0
			this.saveQuantity(item)
		},
		placeOrder() {
			if (this.saving) { return }
			if (this.cartDetail.expires && this.cartDetail.expires <= this.today) {
				this.message = 'This offer has expired and is no longer available for ordering.'
				this.messageStatus = 'alert'
				return
			}
			this.messageTimeout = 0
			let postCartItems = {}
			let total = 0
			this.cartDetail.items.forEach(item => {
				if (item.quantity > 0) {
					postCartItems[item.product_id] = {
						product_id: item.product_id,
						quantity: item.quantity,
						cost: item.cost,
						order_cost: item.cost,
						available: item.available
					}
					total += item.cost * item.quantity
				}
			})
			if (total == 0) {
				this.message = 'Please add item quantities to your order'
				this.messageStatus = 'alert'
				return
			}

			this.saving = true
			this.message = 'Placing ' + this.cartDetail.distributor.company_name + ' order...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'create_distributor_order', data: { distributor_id: this.cartDetail.distributor_id, items: postCartItems, order_source: 'DLINK', submit_on_create: true } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
	                this.message = 'Distributor Order ' + obj.order_number + ' created and placed!'
					this.messageTimeout = 3000
					this.apiCall({ destination: this.compassAPI + '?action=save_dlink_order', data: { cart_id: this.cartDetail.cart_id, order_id: obj.order_id, items: postCartItems } }).then(obj => {
						if (obj.status == 'success') {
							setTimeout(() => {
								this.backToList()
							}, 2500)
						} else {
							this.messageStatus = obj.status
							this.message = obj.message
							this.messageTimeout = 0
						}
					}).catch(err => {
						console.log(err)
					})

				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		backToList() {
			this.showDetail = false
			this.cartDetail = {}
			this.filters.cart_id = ''
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
